import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {DeleteRequest, DeleteResponse} from './types'

export interface Delete<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const deleteRawAlbum: Delete<DeleteRequest, DeleteResponse> = (
  http,
  params,
) => {
  const {ClientID, ID} = params

  const path = '/v1/albums/{id}'.replace('{id}', ID.toString())

  return http.request<DeleteResponse>({
    method: 'DELETE',
    url: `${path}?clientid=${ClientID}`,
  })
}
